var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import dataOf516809 from './_data/516809';
import dataOf516809Mastery from './_data/516809_MASTERY';
import dataOf516809OsmosisVideo from './_data/516809_OSMOSIS_VIDEO';
import dataOf523822 from './_data/523822';
import dataOf523822Mastery from './_data/523822_MASTERY';
import dataOf523822Authess from './_data/523822_AUTHESS';
import dataOf523822Lessons from './_data/523822_LESSONS';
import dataOf622453 from './_data/622453';
import dataOf622353Authess from './_data/622453_AUTHESS';
import dataOf622453Lessons from './_data/622453_LESSONS';
import dataOf622453Mastery from './_data/622453_MASTERY';
import dataOf622453QuizByQuestion from './_data/622453_QUIZ_BY_QUESTION';
import dataOf622453Standard from './_data/622453_STANDARD';
import { configureHandler } from 'mocks/helpers';
export var assignmentEngagementReportV2Map = {
    568749: dataOf622453,
    554121: dataOf523822,
    471204: dataOf516809
};
export var assignmentEngagementReportV2MapByContentType = {
    '568749_QUIZ_BY_QUESTION': dataOf622453QuizByQuestion,
    '568749_MASTERY': dataOf622453Mastery,
    '568749_STANDARD': dataOf622453Standard,
    '568749_AUTHESS': dataOf622353Authess,
    '568749_LESSONS': dataOf622453Lessons,
    '554121_MASTERY': dataOf523822Mastery,
    '554121_AUTHESS': dataOf523822Authess,
    '554121_LESSONS': dataOf523822Lessons,
    '471204_MASTERY': dataOf516809Mastery,
    '471204_OSMOSIS_VIDEO': dataOf516809OsmosisVideo
};
var getAssignmentData = function (courseSectionId, contentType) {
    if (contentType) {
        var contentTypeWithCourseSectionId = "".concat(courseSectionId, "_").concat(contentType);
        return assignmentEngagementReportV2MapByContentType[contentTypeWithCourseSectionId];
    }
    return assignmentEngagementReportV2Map[courseSectionId];
};
export default configureHandler(function (req, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
    var courseSectionId, contentType, assignmentData;
    return __generator(this, function (_a) {
        courseSectionId = req.url.searchParams.get('courseSectionId');
        contentType = req.url.searchParams.get('contentType');
        if (!courseSectionId) {
            return [2 /*return*/, req.passthrough()];
        }
        assignmentData = getAssignmentData(courseSectionId, contentType);
        if (!assignmentData) {
            return [2 /*return*/, req.passthrough()];
        }
        return [2 /*return*/, res(ctx.status(200), ctx.json(assignmentData))];
    });
}); });
